import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';


import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Brand } from './../../../shared/models/brand.model';
import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';


@Component({
  selector: 'app-brand-details-edit-widget',
  templateUrl: './brand-details-edit-widget.component.html',
  styleUrls: ['./brand-details-edit-widget.component.css']
})
export class BrandDetailsEditWidgetComponent implements OnChanges {
   // setup as observable?
   @Input() item_id?: Observable<any[]>; // impliments on changes.
   @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'full'; // side | abstract | full | upadte_password


   @ViewChild('brandForm') form: any; //  access form vars
   bsModalRef: BsModalRef;
   // MODAL
   modalRef: BsModalRef;

   job: any;
   job_id;
  brand_id: any;
  model: Brand;
  baseUploadURL: string;
  brand_types: any;
  brand: any;
  filenameselected: any;
  stripped: any;
  metric_qualification_renewal_date: Date;
  today_format: Date;
  agent_qualification_status_expired: number;



  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) { }

   // check for changes. to load data.
   ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.brand_id = changes.item_id.currentValue;
      this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.brand_id; // no trailing slash
      this.model = new Brand();
      // Set some defaults
      // this.model.is_active = 'Y';
      this.getBrandTypesNoOwner();
      this.getBrandById(this.brand_id);
    }
  }


  ngOnInit() {
  }

  // Functions
  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }

   getBrandTypesNoOwner() {
    this._demoService.getBrandBrandTypesNoOwner().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  

   getBrandById(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      data => { this.brand = data; 
      
      // agent qualification cheker
console.log('Agent Qualification Renewal Date: ', data[0].qualification_renewal_date);

// this.metric_qualification_renewal_date = new Date(this.brand[0].qualification_renewal_date * 1000);
this.metric_qualification_renewal_date = new Date(this.brand[0].qualification_renewal_date);
// this.metric_qualification_renewal_date = data[0].qualification_renewal_date;
this.today_format = new Date(this.gfunc.today);

if (this.metric_qualification_renewal_date <= this.today_format) {
  console.log('NOTICE: This agent qualification has expired');
  this.agent_qualification_status_expired = 1;
}
      
      
      
      },
      err => console.error(err),
      () => console.log('done loading company')
    );
  }


// need to change this below
  editBrand(model){
   // model.job_id = this.job_id;
    this._demoService.updateBrand(model).subscribe(
      data => {  // this.trace_candidate_update = data;
        // refresh the list
       // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
      this.toastr.success('Company Updated');
      this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
     // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
     // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
     this.gfunc.globalBrandView(model.brand_id);
      },
      error => {
       // console.error('Error saving Event!');
        this.toastr.error('Error Updating Brand');
       return console.log(error);
      }
     // err => console.error(err),
     // () => console.log('done updates')
  );}




   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Image / Photo',
      item_id: 1010,
      brand_id: this.brand_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(FileUploadsModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.brand_id = this.brand_id;
    this.bsModalRef.content.item_id = this.brand_id;
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // subscribed to the emitter and get the value.
          //   this.bsModalRef.content.action.take(1).subscribe((value) => {
          // // console.log(value); // here you will get the value of the file
          // // Remove the "uploads/" part from the filename.
          // this.filenameselected = value;
          // this.stripped = this.filenameselected.replace('uploads/', '');
          // // this.model.main_image = this.stripped; // works for simple add not update.
          // // console.log(this.stripped);
          // // console.log(this.model);
          // this.form.logo = this.stripped;
          // // this.form.reset();
          // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
          // this.form.controls['logo'].patchValue(this.form.logo);
          
          // });
          this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....

  }





// :: Parent / Child modal test
public addFileNameFromModal(filename) {

          // this.model.logo = filename;
          this.form.controls['logo'].patchValue(filename); // works by setting the new frorm value from parent modal.

// this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};



}
